import { useCallback, useEffect, useState } from "react";

import { validateAdesaoEmail } from "features/adesao-email/services/adesaoEmailApi";
import type { EmailCopy } from "features/adesao-email/types";

const LOADING: EmailCopy = {
  title: "Validação de E-mail",
  subTitle: "",
  text: "Carregando...",
};

const SUCCESS: EmailCopy = {
  title: "E-mail validado!",
  subTitle:
    "Agora você pode acessar seu portal e visualizar todas suas unidades em um único login.",
  text: "Seu e-mail foi validado com sucesso!",
};

const EXPIRED: EmailCopy = {
  title: "E-mail expirado!",
  subTitle:
    "O seu e-mail de ativação expirou, para validar novamente basta você reenvia-lo novamente para ativar",
  text: "Não foi possível concluir seu cadastro, seu e-mail de ativação foi expirado, favor tente novamente",
};

const STEPPERS = [
  "Seu documento",
  "Cadastre sua Residência ou Loja",
  "Medidor",
  "Dados de Cobrança",
  "Dados Pessoais",
  "Validar Cadastro",
  "Cadastro Concluído",
];

export function useAdesaoEmail(): {
  emailState: EmailCopy;
  errorState: number | null;
  loading: boolean;
  steppers: string[];
} {
  const [loading, setLoading] = useState(false);
  const [emailState, setEmailState] = useState<EmailCopy>(LOADING);
  const [errorState, setErrorState] = useState<number | null>(null);

  const requestValidationEmail = useCallback(
    async (token: string | null, userId: string | null) => {
      setLoading(true);
      try {
        await validateAdesaoEmail(userId, token);
        setEmailState(SUCCESS);
      } catch {
        setEmailState(EXPIRED);
        setErrorState(7);
      }
      setLoading(false);
    },
    []
  );

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const token = params.get("token");
    const userId = params.get("user-id");
    void requestValidationEmail(token, userId);
  }, [requestValidationEmail]);

  return { emailState, errorState, loading, steppers: STEPPERS };
}
